jQuery(document).ready(function () {
    $(document).on('click', '.dnJs-plusContent', function (e) {

        var button = $(this);
        var classSelector = $('.' + button.attr('data-classSelector'));
        var classContainer = $('.' + button.attr('data-classContainer'));
        var maxSelector = classSelector.length;
        var selector = 1;

        classSelector.each(function () {
            var el = $(this);
            var hiddenAttr = el.attr('hidden');

            if (typeof hiddenAttr !== typeof undefined && hiddenAttr !== false) {
                el.removeAttr('hidden');
                if (selector >= maxSelector) {
                    classContainer.attr('hidden', 'hidden');
                }
                return false;
            }
            selector++;
        });

    });
});